const PageLoadingState: React.FC = () => {
  return <div className="flex h-screen flex-col"></div>;
};

export default PageLoadingState;
